// extracted by mini-css-extract-plugin
export var title = "checkout-module--title--LBJTf";
export var loading = "checkout-module--loading--2NRVc";
export var link = "checkout-module--link--1AVAC";
export var marginBottom = "checkout-module--marginBottom--1XWjo";
export var policy = "checkout-module--policy--1A_Nz";